module.exports = __webpack_public_path__ + "img/Z86_16.ed0a4d63.jpg";